import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import './mcaPageStyles.css';
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from '../components/ContactAdmissionsStrip';

const MCAadmission = () => {
  // State to manage active tab.
  const [activeTab, setActiveTab] = useState('introduction');
  const [showForm, setShowForm] = useState(false);
  const openPdfInNewTab = (event) => {
    event.preventDefault();
    window.open(event.currentTarget.href, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Navbar />
      <CTAButtons />
      <PageHeader
        title="Master of Computer Applications (MCA)"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Master of Computer Applications (MCA)' }]}
      />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <div className="mca-ig-wrapper ">
        {/* Navigation Tabs */}
        <div className="mca-nav-container">
          <div className={`mca-nav-item ${activeTab === 'introduction' ? 'mca-active' : ''}`} onClick={() => setActiveTab('introduction')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
            <span>Introduction</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'eligibility' ? 'mca-active' : ''}`} onClick={() => setActiveTab('eligibility')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            <span>Eligibility Criteria</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'documents' ? 'mca-active' : ''}`} onClick={() => setActiveTab('documents')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
            <span>Documents Required</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'admission-procedure' ? 'mca-active' : ''}`} onClick={() => setActiveTab('admission-procedure')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
            <span>Admission Procedure</span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'fees-details' ? 'mca-active' : ''}`} onClick={() => setActiveTab('fees-details')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path><line x1="12" y1="16" x2="12" y2="18"></line><line x1="12" y1="6" x2="12" y2="8"></line></svg>
            <span>Fees Details<br /><span style={{ fontSize: '9px', opacity: 0.8 }}>(शुल्क विवरण)</span></span>
          </div>

          <div className={`mca-nav-item ${activeTab === 'mode-of-payment' ? 'mca-active' : ''}`} onClick={() => setActiveTab('mode-of-payment')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
            <span>Mode of Payment</span>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="mca-main-card">

          {/* --- TAB 1: INTRODUCTION --- */}
          {activeTab === 'introduction' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="3" y1="9" x2="21" y2="9"></line>
                    <path d="M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6"></path>
                  </svg>
                </div>
                <div className="mca-title">Master of Computer Applications (MCA)</div>
              </div>

              <div className="mca-intro-stats-row">
                <div className="mca-intro-stat-card">
                  <span className="mca-intro-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                  </span>
                  <span className="mca-intro-stat-label">Duration</span>
                  <span className="mca-intro-stat-value">2 Years</span>
                </div>

                <div className="mca-intro-stat-card">
                  <span className="mca-intro-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </span>
                  <span className="mca-intro-stat-label">Intake</span>
                  <span className="mca-intro-stat-value">300 Seats</span>
                </div>

                <div className="mca-intro-stat-card">
                  <span className="mca-intro-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </span>
                  <span className="mca-intro-stat-label">Mode</span>
                  <span className="mca-intro-stat-value">Offline</span>
                </div>
              </div>

              <p className="mca-intro-text-block">
                Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) offers an AICTE-approved Master of Computer Applications (MCA) program. The MCA is a postgraduate degree program designed to provide students with a comprehensive understanding of computer science and its applications in the real world. The MCA program has a duration of 2 years with the total intake at TIMSCDR Mumbai being 300 seats. Six months of industry internship is provided in the last semester of the course. The mode of the program will be offline.
              </p>
              <p className="mca-intro-text-block">
                As the demand for skilled IT professionals continues to grow across industries, the MCA program equips students with the technical expertise and problem-solving abilities needed to meet the evolving challenges of the digital world. Graduates of this program are well-prepared for careers as software developers, system analysts, IT consultants, database administrators, and other key roles in both the public and private sectors. The curriculum is designed to foster innovation, critical thinking, and a deep understanding of modern computing systems, making MCA an ideal choice for individuals seeking to build a dynamic and rewarding career in information technology.
              </p>
            </>
          )}

          {/* --- TAB 2: ELIGIBILITY CRITERIA --- */}
          {activeTab === 'eligibility' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <div className="mca-title">Eligibility Criteria</div>
              </div>

              <div className="mca-elig-grid">
                <div className="mca-elig-column">
                  <div className="mca-elig-header-row">
                    <span className="mca-step-badge-solid">1</span>
                    <h5 className="mca-elig-main-title">Admission to the First Year of Two-years full-time Post Graduate Degree course in Master of Computer Applications (MCA) for the academic year 2026-27</h5>
                  </div>
                  <div className="mca-elig-card">
                    <span className="mca-elig-sublabel" style={{ textTransform: 'none', fontWeight: 600 }}>Eligibility for Maharashtra State Candidature Candidates, All India Candidature Candidates, Union Territory of Jammu and Kashmir, and Union Territory of Ladakh Migrant Candidature Candidates.</span>
                    <p style={{ marginBottom: "10px", marginTop: "10px", fontSize: "0.95rem" }}>The Candidate:</p>
                    <ul className="mca-elig-list">
                      {[
                        "Should be a citizen of India;",
                        "Should have passed any graduation degree (e.g.: B.E. or B.Tech. or B.Sc or B.Com. or B.A. or B. Voc. or BCA etc.,), preferably with Mathematics at 10+2 level or at Graduation level and obtained at least fifty per cent marks (at least forty-five per cent. in case of candidates of Reserved Categories, Economically Weaker Section, and Persons with Disability category belonging to the Maharashtra State) in the qualifying examination;",
                        "Should have obtained non zero score in MAH-MCA-CET 2026 conducted by the Competent Authority."
                      ].map((text, idx) => (
                        <li key={idx} className="mca-elig-item">
                          <span className="mca-list-num">{String.fromCharCode(97 + idx)}</span>
                          <span>{text}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="mca-card-divider"></div>

                    <span className="mca-elig-sublabel" style={{ textTransform: 'none', fontWeight: 600 }}>Non-Resident Indian (NRI) or Overseas Citizen of India (OCI) or Person of Indian Origin (PIO), Children of Indian  workers in the Gulf countries, Foreign National Candidature Candidates.</span>
                    <ul className="mca-elig-list">
                      {[
                        "The candidate should have passed any graduation degree (e.g.: B.E. or B.Tech. or B.Sc or B.Com. or B.A. or B. Voc. or BCA etc.,) preferably with Mathematics at 10+2 level or at Graduation level and obtained at least fifty per cent. marks in the qualifying examination.",
                        "Any other eligibility criteria and requirement declared from time to time by the appropriate authority as defined under the Act;"
                      ].map((text, idx) => (
                        <li key={idx} className="mca-elig-item">
                          <span className="mca-list-num">{idx + 1}</span>
                          <span>{text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="mca-elig-column">
                  <div className="mca-elig-header-row">
                    <span className="mca-step-badge-solid">2</span>
                    <h3 className="mca-elig-main-title">2. Second Year (Lateral Entry) Admission. –</h3>
                  </div>
                  <div className="mca-elig-card">
                    <span className="mca-elig-sublabel" style={{ textTransform: 'none', fontWeight: 600 }}>Maharashtra State Candidature Candidates and All India Candidature Candidates.-</span>
                    <ul className="mca-elig-list" style={{ marginTop: "10px" }}>
                      <li className="mca-elig-item">
                        <span className="mca-list-num">1</span>
                        <span>The candidate should be a citizen of India;</span>
                      </li>
                      <li className="mca-elig-item">
                        <span className="mca-list-num">2</span>
                        <span>The candidate should have passed B.Tech.(Computer Science and Engineering (CSE) or Information Technology (IT)) or B.E. (Computer Science and Engineering (CSE) or Information Technology (IT)) or Bachelor of Computer Applications (BCA) (4 years);</span>
                      </li>
                      <li className="mca-elig-item">
                        <span className="mca-list-num">3</span>
                        <span>Any other eligibility criteria and requirement declared from time to time by the appropriate authority as defined under the Act.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* --- TAB 3: DOCUMENTS REQUIRED --- */}
          {activeTab === 'documents' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <span className="mca-info-icon">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                      <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                    </svg>
                  </span>
                </div>
                <div className="mca-title">Documents Required</div>
              </div>

              <div className="mca-docs-grid">
                <div className="mca-doc-column">
                  <div className="mca-doc-col-header">
                    <span className="mca-col-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </span>
                    List of photocopies of Certificates to be submitted:
                  </div>
                  <ul className="mca-doc-list">
                    {[
                      "MAH-MCA-CET 2026 score card.",
                      "SC Verification letter",
                      "Institute Seat Allotment Letter from the CET CELL (if applicable)",
                      "CET Admission Freeze/ Confirmation letter",
                      "Statement of marks & certificate of SSC, HSC, and Graduation (all semester/year)",
                      "Migration and Provisional Passing Certificate for those candidates who passed from any University other than the University of Mumbai.",
                      "Certificate of Indian Nationality (School Leaving Certificate indicating the Nationality of the candidate as ‘Indian’/ Valid Indian Passport/ Birth Certificate of the candidate indicating the place of birth in India.)",
                      "Domicile Certificate (if applicable), clearly indicating the place of permanent residence of the candidate or father or mother or husband.",
                      "Aadhaar Card and PAN Card Copy",
                      "ABC ID Number (APAR) Copy",
                      "Declaration of the Candidate for the Hindi Linguistic Minority Community or Leaving Certificate having information pertaining to Mother tongue Hindi (Minority Candidates)",
                      "Caste/Tribe Validity Certificate (if applicable)",
                      "Non-Creamy Layer Certificate valid up to 31 March 2027 (if applicable).",
                      "Certificates in Proforma A, B1, B2, C, D, E, G1, G2, J, K, L, M, O, U, V, W1 & W2 as applicable (Mentioned in DTE/CET cell brochure)",
                      "Any other relevant document"
                    ].map((item, idx) => (
                      <li key={idx} className="mca-doc-item">
                        <span className="mca-icon-check">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                            <polyline points="22 4 12 14.01 9 11.01"></polyline>
                          </svg>
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mca-doc-column">
                  <div className="mca-doc-col-header">
                    <span className="mca-col-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </span>
                    After verification, if provisionally confirmed in the Institute, candidate has to submit the following documents:
                  </div>
                  <ul className="mca-doc-list">
                    {[
                      "All original certificates mentioned above with attested photocopies of the same.",
                      "Affidavit for Minority Status on a ₹100/- non-judicial stamp paper in the institute-specified format (only for Linguistic Minority candidates).",
                      "Gap Certificate for the break after completion of Graduation examination on a ₹100/- non-judicial stamp paper in the institute specified format (if applicable).",
                      "Anti ragging reference no. copy.",
                      "Physical Fitness Certificate from a registered Medical Practitioner.",
                      "Five recent passport size colour photographs.",
                      "Any other relevant document."
                    ].map((item, idx) => (
                      <li key={idx} className="mca-doc-item">
                        <span className="mca-icon-check">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                        </span>
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="mca-info-text mt-3">
                    <span style={{ color: '#5a4ad1', marginRight: '8px' }}>For more information about Admission, log on: <a href="https://cetcell.mahacet.org" target="_blank" rel="noopener noreferrer" style={{ color: '#5a4ad1' }}>https://cetcell.mahacet.org</a></span>
                  </div>
                </div>
              </div>
            </>
          )}
          {/* --- TAB 4: ADMISSION PROCEDURE --- */}
          {activeTab === 'admission-procedure' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                    <path d="M9 14h6"></path>
                    <path d="M9 10h6"></path>
                    <path d="M9 18h6"></path>
                  </svg>
                </div>
                <div className="mca-title">Admission Procedure</div>
              </div>

              <p className="mca-text-content">
                Admissions for the Master in Computer Applications (MCA) program are conducted as per the norms of the Admission Regulatory Authority (ARA) and the MH-CET Cell under the Directorate of Technical Education (DTE), Government of Maharashtra (GoM). The rules and regulations prescribed by the All India Council for Technical Education (AICTE), Government of Maharashtra, DTE Maharashtra, and the University of Mumbai are strictly followed. Admissions are based on the eligibility criteria and merit in the respective entrance examinations. All admissions are carried out according to the schedule published in leading newspapers and on the MH-CET cell website.
              </p>

              <h3 className="mca-sub-heading" style={{ display: 'flex', alignItems: 'center', gap: '10px', borderLeft: 'none', paddingLeft: 0 }}>
                <span style={{ color: '#5a4ad1' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="6" height="6" rx="1"></rect>
                    <rect x="9" y="9" width="6" height="6" rx="1"></rect>
                    <rect x="16" y="16" width="6" height="6" rx="1"></rect>
                    <line x1="5" y1="8" x2="5" y2="12"></line>
                    <line x1="5" y1="12" x2="9" y2="12"></line>
                    <line x1="12" y1="15" x2="12" y2="19"></line>
                    <line x1="12" y1="19" x2="16" y2="19"></line>
                  </svg>
                </span>
                Admission Process Flow Diagram
              </h3>

              <div className="mca-workflow-wrapper">
                <img
                  src="/images/program/WhatsApp-Image-2025-05-16-at-2.49.18-PM-550x550xc.jpeg"
                  alt="MCA Admission Workflow"
                  className="mca-workflow-image"
                />
              </div>
            </>
          )}

          {/* --- TAB 5: FEES DETAILS --- */}
          {activeTab === 'fees-details' && (
            <>
              <div className="mca-header">
                <div className="mca-info-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
                    <rect x="2" y="6" width="20" height="12" rx="2"></rect>
                    <circle cx="12" cy="12" r="2"></circle>
                    <path d="M6 12h.01M18 12h.01"></path>
                  </svg>
                </div>
                <div className="mca-title">Fees Details (शुल्क विवरण)</div>
              </div>

              <p className="mca-text-content">
                Explore the MCA course duration and fees at TIMSCDR here. The Mumbai University MCA fees, inclusive of various charges, ensure accessibility to quality education, with provisions for refunds and financial assistance available for eligible students. TIMSCDR, is one of the top 10 colleges for MCA in Mumbai with fees approved by FRA (Fee Regulating Authority). Below is the approved Master in Computer Application category wise fees for the A.Y. 2026-27 by Fee Regulating Authority, M.S. for 1st year Students.
              </p>

              {/* <div className="mca-fees-table-container">
                <table className="mca-fees-table">
                  <thead>
                    <tr>
                      <th className="mca-fees-th">Particulars</th>
                      <th className="mca-fees-th" style={{ textAlign: 'right' }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="mca-fees-td">Tuition fees<br />(शिक्षण शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">1,56,087/-<br />(१,५६,०८७/ -)</td>
                    </tr>
                    <tr>
                      <td className="mca-fees-td">Development fees<br />(विकास शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">23,413/-<br />(२३,४१३/-)</td>
                    </tr>
                    <tr>
                      <td className="mca-fees-td">Caution Money / Deposit (Refundable) (सुरक्षा जमा शुल्क)</td>
                      <td className="mca-fees-td mca-fees-amount">₹ 3000/-<br />(३,०००/-)</td>
                    </tr>
                    <tr className="mca-fees-total-row">
                      <td className="mca-fees-total-label">Total Fees<br />(एकूण /कुल शुल्क)</td>
                      <td className="mca-fees-total-amount">1,79,500/-<br />(१,७९,५००/-)</td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
              <div className="mca-fees-table-container">
  <table className="mca-fees-table">
    <thead className="mca-fees-thead">
      <tr>
        <th className="mca-fees-th">SR. NO</th>
        <th className="mca-fees-th col-particular">PARTICULAR</th>
        <th className="mca-fees-th">
          REGULAR AMOUNT<br />IN RS.
        </th>
        <th className="mca-fees-th">
          OBC/EBC/SEBC<br />50% ON TUITION<br />FEES (MALE)<br />AMOUNT IN RS.
        </th>
        <th className="mca-fees-th">
          OBC/EBC/SEBC<br />100% ON TUITION<br />FEES (FEMALE)<br />AMOUNT IN RS.
        </th>
        <th className="mca-fees-th">
          SC/ST<br />AMOUNT IN<br />RS.
        </th>
        <th className="mca-fees-th">
          VJNT / SBC<br />AMOUNT IN<br />RS.
        </th>
        <th className="mca-fees-th">
          TFWS<br />AMOUNT IN<br />RS.
        </th>
      </tr>
    </thead>
    <tbody className="mca-fees-tbody">
      <tr>
        <td className="mca-fees-td col-srno">1</td>
        <td className="mca-fees-td col-particular">Tuition Fees</td>
        <td className="mca-fees-td col-amount">1,56,087/-</td>
        <td className="mca-fees-td col-amount">78,044/-</td>
        <td className="mca-fees-td col-amount">-</td>
        <td className="mca-fees-td col-amount">-</td>
        <td className="mca-fees-td col-amount">-</td>
        <td className="mca-fees-td col-amount">-</td>
      </tr>
      <tr>
        <td className="mca-fees-td col-srno">2</td>
        <td className="mca-fees-td col-particular">Development Fees</td>
        <td className="mca-fees-td col-amount">23,413/-</td>
        <td className="mca-fees-td col-amount">23,413/-</td>
        <td className="mca-fees-td col-amount">23,413/-</td>
        <td className="mca-fees-td col-amount">-</td>
        <td className="mca-fees-td col-amount">23,413/-</td>
        <td className="mca-fees-td col-amount">23,413/-</td>
      </tr>
      <tr>
        <td className="mca-fees-td col-srno">3</td>
        <td className="mca-fees-td col-particular">Library & Laboratory Deposit</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
        <td className="mca-fees-td col-amount">3,000/-</td>
      </tr>
      <tr className="mca-fees-total-row">
        <td colSpan="2" className="mca-fees-total-label">Total</td>
        <td className="mca-fees-total-amount">1,82,500/-</td>
        <td className="mca-fees-total-amount">1,04,457/-</td>
        <td className="mca-fees-total-amount">26,413/-</td>
        <td className="mca-fees-total-amount">3,000/-</td>
        <td className="mca-fees-total-amount">26,413/-</td>
        <td className="mca-fees-total-amount">26,413/-</td>
      </tr>
    </tbody>
  </table>
</div>

              {/* --- NEW PDF DOWNLOAD SECTION --- */}
              <div className="mca-pdf-section" style={{ margin: '25px 0', padding: '20px', backgroundColor: '#f4f3ff', borderRadius: '8px', border: '1px solid #e0dcf8', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
                <h4 style={{ margin: 0, color: '#333', fontSize: '15px', lineHeight: '1.4' }}>
                  MCA & MCA (Integrated) First Year Fee Structure (2026-27)
                </h4>
                <a href="/pdf/admission/MCA/FRA Fees Structure For MCA Course.pdf" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: '#5a4ad1', color: '#fff', padding: '10px 18px', borderRadius: '6px', textDecoration: 'none', fontWeight: '500', fontSize: '14px', transition: 'background-color 0.2s' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7 10 12 15 17 10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                  View / Download PDF
                </a>
              </div>
              {/* ------------------------------ */}

              <h3 className="mca-sub-heading" style={{ borderLeftColor: '#5a4ad1', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: 0, borderLeft: 'none' }}>
                <span style={{ color: '#5a4ad1' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </span>
                Fee Refund Policy
              </h3>

              <p className="mca-text-content" style={{ fontWeight: 600, marginBottom: "15px" }}>
                Refund of Tuition, Development fees after cancellation of admission :
              </p>

              <div className="mca-refund-box">
                <ul className="mca-refund-list">
                  <li className="mca-refund-item">
                    <div className="mca-refund-number">1</div>
                    <div className="mca-refund-text">
                      The refund of fees before cut-off date of admission shall be made within two days i.e. total fees minus the processing charges of Rs.1,000/-, or refund rule shall be as per the guidelines of the appropriate authorities or the State Government, as the case may be.
                    </div>
                  </li>
                  <li className="mca-refund-item">
                    <div className="mca-refund-number">2</div>
                    <div className="mca-refund-text">
                      If the admission is cancelled after the cut-off date of admission declared by the Competent authority, there shall be no refund.
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}

          {/* --- TAB 6: MODE OF PAYMENT --- */}
      {activeTab === 'mode-of-payment' && (
      <>
        <div className="mca-header">
          <div className="mca-info-icon-wrapper">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mca-info-icon">
              <rect x="2" y="5" width="20" height="14" rx="2"></rect>
              <line x1="2" y1="10" x2="22" y2="10"></line>
            </svg>
          </div>
          <div className="mca-title">Mode of Payment</div>
        </div>

        {/* TOP GRID: Financial Assistance & QR Code */}
        <div className="mca-payment-grid">
          <div className="mca-payment-col">
            <div className="mca-payment-subhead">
              <span className="mca-subhead-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="2" y1="10" x2="22" y2="10"></line>
                  <line x1="2" y1="20" x2="22" y2="20"></line>
                  <line x1="6" y1="10" x2="6" y2="20"></line>
                  <line x1="10" y1="10" x2="10" y2="20"></line>
                  <line x1="14" y1="10" x2="14" y2="20"></line>
                  <line x1="18" y1="10" x2="18" y2="20"></line>
                  <path d="M12 2l10 7H2L12 2z"></path>
                </svg>
              </span>
              Financial Assistance
            </div>
            <div className="mca-payment-card">
              <p className="mca-fin-text">
                Financial Assistance is available as education loan for the bonafide students of institute from reputed banks. Interested students can utilize the benefit after getting admission to the course. Fee is chargeable per annum and is subject to revision from time to time as per notification from Fees Regulating Authority and University of Mumbai.
              </p>
            </div>
          </div>

          <div className="mca-payment-col">
            <div className="mca-payment-subhead">
              <span className="mca-subhead-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </span>
              Mode of Payment
            </div>
            <div className="mca-payment-card">
              <div className="mca-qr-container">
                <div className="mca-qr-placeholder">
                  <div className="mca-qr-inner">
                    <img
                      src="/images/icons/scan-fees-qr.jpg"
                      alt="Payment QR Code"
                      className="mca-qr-img"
                    />
                  </div>
                </div>
                <p className="mca-qr-text">
                  Pay fees via online payment portal, scan below QR code OR Click Here
                </p>
                <button className="mca-pay-btn">
                  Click Here
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* EXTRA SECTIONS: Bank Details and Additional Payment Modes */}
        <div className="mca-extra-sections-wrapper">
          
          <div className="mca-bank-details-card">
            <h3 className="mca-bank-details-heading">Other Payment Modes & Bank Details</h3>
            
            <div className="mca-bank-modes-list">
              <div className="mca-bank-mode-item"><strong>1) Credit/ Debit Card/ UPI:</strong> Scan the QR code above or use the payment portal.</div>
              <div className="mca-bank-mode-item"><strong>2) Demand Draft:</strong> In Favour of “Thakur Institute of Management Studies, Career Development and Research”</div>
              <div className="mca-bank-mode-item"><strong>3) Net Banking/ RTGS/NEFT:</strong> Use the bank details provided below.</div>
            </div>

            <div className="mca-bank-table-container">
              <table className="mca-bank-table">
                <tbody>
                  <tr>
                    <td className="mca-bank-td mca-bank-td-label">Account Name</td>
                    <td className="mca-bank-td">Thakur Institute of Management Studies Career Development & Research</td>
                  </tr>
                  <tr>
                    <td className="mca-bank-td mca-bank-td-label">Bank Name</td>
                    <td className="mca-bank-td">IDFC First Bank</td>
                  </tr>
                  <tr>
                    <td className="mca-bank-td mca-bank-td-label">Account Number</td>
                    <td className="mca-bank-td">10066136306</td>
                  </tr>
                  <tr>
                    <td className="mca-bank-td mca-bank-td-label">IFSC Code</td>
                    <td className="mca-bank-td">IDFB0040114</td>
                  </tr>
                  <tr>
                    <td className="mca-bank-td mca-bank-td-label">Branch</td>
                    <td className="mca-bank-td">Malad</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* NOTE SECTION: Applicable Fee Concessions */}
          <div className="mca-note-card">
            <h3 className="mca-note-heading">Note: Applicable Fee Concessions</h3>
            <p className="mca-note-text">
              Students belonging to OBC/EBC/EWS/SC/ST/SBC/VJNT categories who have been allotted admission through the CAP Round shall be eligible for the applicable fee concessions/benefits, subject to the submission of the following mandatory documents at the time of admission:
            </p>

            <div className="mca-note-table-container">
              <table className="mca-note-table">
                <thead>
                  <tr>
                    <th className="mca-note-th col-sr">Sr. No.</th>
                    <th className="mca-note-th">Name of Document</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="mca-note-td-center">1</td>
                    <td className="mca-note-td">
                      <strong>Income Certificate issued by the Government Tahsildar Office.</strong>
                      <span className="mca-note-list-item">• For OBC/EBC/EWS/SBC/VJNT categories: Annual family income should be up to ₹8 lakh.</span>
                      <span className="mca-note-list-item">• For SC/ST categories: No income limits applicable.</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="mca-note-td-center">2</td>
                    <td className="mca-note-td">Caste Certificate (If applicable)</td>
                  </tr>
                  <tr>
                    <td className="mca-note-td-center">3</td>
                    <td className="mca-note-td">Caste Validity Certificate (If applicable)</td>
                  </tr>
                  <tr>
                    <td className="mca-note-td-center">4</td>
                    <td className="mca-note-td">Non-creamy layer Certificate (If applicable)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
        </div>

        {/* IMPORTANT DOCUMENTS SECTION */}
   <div className="mca-imp-docs-section">
          <div className="mca-imp-header">
            <span className="mca-subhead-icon-wrapper">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
            </span>
            IMPORTANT DOCUMENTS
          </div>

          <div className="mca-imp-grid">
            {/* Vacancy Position */}
            <a href="/pdf/admission/MCA/202627/Vacancy-Position-for-First-Year-Master-of-Computer-Applications-(MCA)-for-the-Academic-Year-2026-27.pdf" target="_blank" rel="noopener noreferrer" onClick={openPdfInNewTab} className="mca-doc-card-small">
              <div className="mca-doc-card-content">
                <span className="mca-doc-icon-small">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                </span>
                <span className="mca-doc-title-small">Vacancy Position for First-Year Master of Computer Applications (MCA) for the Academic Year 2026–27</span>
              </div>
              <span className="mca-doc-view-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </span>
            </a>

            {/* General Merit List */}
            <a href="/pdf/admission/MCA/202627/General-Merit-List-for-Institute-Level-and-Against-CAP-Vacancies-for-MCA-Course-Admissions.pdf" target="_blank" rel="noopener noreferrer" onClick={openPdfInNewTab} className="mca-doc-card-small">
              <div className="mca-doc-card-content">
                <span className="mca-doc-icon-small">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                </span>
                <span className="mca-doc-title-small">General Merit List for Institute-Level and Against-CAP Vacancies for MCA Course Admissions</span>
              </div>
              <span className="mca-doc-view-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </span>
            </a>

            {/* Schedule of Activities */}
            <a href="/pdf/admission/MCA/202627/Schedule-of-Activities-for-Institute-Level-and-Against-CAP-Vacancy-Admissions-for-A.Y.-2026-27.pdf" target="_blank" rel="noopener noreferrer" onClick={openPdfInNewTab} className="mca-doc-card-small">
              <div className="mca-doc-card-content">
                <span className="mca-doc-icon-small">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                </span>
                <span className="mca-doc-title-small">Schedule of Activities for Institute-Level and Against-CAP Vacancy Admissions for A.Y. 2026–27</span>
              </div>
              <span className="mca-doc-view-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </span>
            </a>

            {/* Admission Notice */}
            <a href="/pdf/admission/MCA/202627/Notice-for-Institute-Level-and-Against-CAP-Vacancy-Admissions-for-First-Year-Master-of-Computer-Applications-(MCA)-for-A.Y.-2026-27.pdf" target="_blank" rel="noopener noreferrer" onClick={openPdfInNewTab} className="mca-doc-card-small">
              <div className="mca-doc-card-content">
                <span className="mca-doc-icon-small">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line></svg>
                </span>
                <span className="mca-doc-title-small">Notice for Institute-Level and Against-CAP Vacancy Admissions for First-Year Master of Computer Applications (MCA) for A.Y. 2026–27</span>
              </div>
              <span className="mca-doc-view-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
              </span>
            </a>
          </div>
        </div>
      </>
    )}
        </div>
      </div>
      {/* --- NEW: STYLED 3-COLUMN ADMISSION CONTACT SECTION --- */}
      <div className="mca-contact-section">
        <div className="mca-contact-header">
          <h2 className="mca-contact-title">Admission Office & Contact Details</h2>
          <p className="mca-contact-subtitle">For admission-related queries and assistance</p>
        </div>

        <div className="mca-contact-grid">
          
          {/* Card 1: Location */}
          <div className="mca-contact-card">
            <div className="mca-contact-icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div className="mca-contact-card-content">
              <h4 className="mca-contact-card-title">Admission Office</h4>
              <p className="mca-contact-card-text">
                Administrative Office, Ground Floor<br />
                Thakur Institute of Management Studies, Career Development & Research (TIMSCDR)<br />
                Thakur Educational Campus, Shyamnarayan Thakur Marg, Thakur Village, Kandivali (East), Mumbai – 400101, Maharashtra.
              </p>
            </div>
          </div>

          {/* Card 2: Hours */}
          <div className="mca-contact-card">
            <div className="mca-contact-icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div className="mca-contact-card-content">
              <h4 className="mca-contact-card-title">Office Hours</h4>
              <p className="mca-contact-card-text" style={{ marginBottom: '16px' }}>
                9:30 AM to 5:30 PM<br />
                (As per CET Cell Schedule)
              </p>
              <div className="mca-card-divider"></div>
              <p className="mca-contact-card-text">
                Monday to Friday<br />
                (Except Public Holidays)
              </p>
            </div>
          </div>

          {/* Card 3: Contacts */}
          <div className="mca-contact-card">
            <div className="mca-contact-icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div className="mca-contact-card-content">
              <h4 className="mca-contact-card-title">Admission Contacts</h4>
              
              <div className="mca-contact-person">
                <div className="mca-person-details">
                  <strong>Mr. Shailesh Sharma</strong>
                  <a href="tel:9833462829" className="mca-phone-link">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    98334 62829
                  </a>
                </div>
                {/* <a href="tel:9833462829" className="mca-call-btn">Call</a> */}
              </div>
<div className="mca-card-divider"></div>
              <div className="mca-contact-person" style={{ marginTop: '16px' }}>
                <div className="mca-person-details">
                  <strong>Mr. Prashant Satam</strong>
                  <a href="tel:9757021101" className="mca-phone-link">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    97570 21101
                  </a>
                </div>
                {/* <a href="tel:9757021101" className="mca-call-btn">Call</a> */}
              </div>

            </div>
          </div>

        </div>
      </div>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </>
  );
};

export default MCAadmission;
